<button [disabled]="disabledBtn" class="btn btn-link" (click)="openPreview()">{{linkTitle}}</button>
